'use strict';

import React from 'react'

import _ from 'lodash'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

import CreationForm from '@/Form/CreationForm'

import { form as _config } from '@Config/Blog/blog'

const { app } = window;

const config = _.cloneDeep(_config);

config.fields['mobile_notif'] =
{
	label: 'Envoyer une notification aux utilisateurs de l\'application mobile',
	type: 'checkbox'
};

export default class NewBlogPage extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };

		this.handleSessionChange = this.handleSessionChange.bind(this);
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		if (app.state.session.EC instanceof Object)
		{
			component.handleSessionChange();
		}
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange ()
	{
		const component = this, props = this.props, state = this.state;

		if (app.state.session.EC instanceof Object === false) return;

		component.setState(
		{
			EC_id: app.state.session.EC.id
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let EC_id = state.EC_id, form;

		if (EC_id)
		{
			config.hookComponentWillMount = function ()
			{
				const component = this, props = this.props, state = this.state;

				let form_data = component.state.form_data;

				form_data['blog[type]'] = 'EC';
				form_data['blog[EC]']   = EC_id;

				component.setState(
				{
					form_data: form_data
				});
			};

			form =
			(
				<TransitionGroup className="page-form-container">

					<CSSTransition
						classNames="a-form-transition"
						appear={ true }
						enter={ true }
						exit={ true }
						timeout={{ enter: 240, exit: 320, appear: 500 }}>

						<CreationForm config={ config } className="u-no-margin-top" />

					</CSSTransition>

				</TransitionGroup>
			);
		}

		var output =
		(
			<Layout page_title="Nouvel article de blog" history={ props.history }
				page_title_pathname="/accueil/mon-espace/blog/nouvel-article">

				<div className="page-content">

					<div className="o-content">

						{ form }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
